import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { toast } from 'react-hot-toast';
import { 
  FiUser, 
  FiLock, 
  FiSave,
  FiShield
} from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import './AdminSettings.css';

const AdminSettings = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('profile');
  const [saving, setSaving] = useState(false);
  
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      toast.error('Yeni şifreler eşleşmiyor');
      return;
    }

    if (passwordData.newPassword.length < 6) {
      toast.error('Şifre en az 6 karakter olmalıdır');
      return;
    }

    setSaving(true);
    try {
      await api.put('/auth/change-password', {
        currentPassword: passwordData.currentPassword,
        newPassword: passwordData.newPassword
      });
      toast.success('Şifre başarıyla değiştirildi');
      setPasswordData({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      });
    } catch (error) {
      toast.error(error.response?.data?.message || 'Şifre değiştirilemedi');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="admin-settings">
      {/* Tabs */}
      <div className="settings-tabs">
        <button
          className={`settings-tab ${activeTab === 'profile' ? 'active' : ''}`}
          onClick={() => setActiveTab('profile')}
        >
          <FiUser />
          Profil
        </button>
        <button
          className={`settings-tab ${activeTab === 'security' ? 'active' : ''}`}
          onClick={() => setActiveTab('security')}
        >
          <FiShield />
          Güvenlik
        </button>
      </div>

      {/* Content */}
      <motion.div 
        className="settings-content"
        key={activeTab}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
      >
        {activeTab === 'profile' && (
          <div className="settings-section">
            <h2>Profil Bilgileri</h2>
            <div className="profile-card">
              <div className="profile-avatar">
                {user?.username?.charAt(0).toUpperCase() || 'A'}
              </div>
              <div className="profile-info">
                <h3>{user?.username || 'Admin'}</h3>
                <p>{user?.email || 'admin@bmkegitim.com'}</p>
                <span className="profile-role">{user?.role || 'admin'}</span>
              </div>
            </div>
            <div className="info-grid">
              <div className="info-item">
                <label>Kullanıcı Adı</label>
                <span>{user?.username || 'Admin'}</span>
              </div>
              <div className="info-item">
                <label>E-posta</label>
                <span>{user?.email || 'admin@bmkegitim.com'}</span>
              </div>
              <div className="info-item">
                <label>Rol</label>
                <span className="capitalize">{user?.role || 'admin'}</span>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'security' && (
          <div className="settings-section">
            <h2>Şifre Değiştir</h2>
            <form onSubmit={handlePasswordChange} className="password-form">
              <div className="form-group">
                <label className="form-label">
                  <FiLock />
                  Mevcut Şifre
                </label>
                <input
                  type="password"
                  className="form-input"
                  placeholder="••••••••"
                  value={passwordData.currentPassword}
                  onChange={(e) => setPasswordData(prev => ({
                    ...prev,
                    currentPassword: e.target.value
                  }))}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">
                  <FiLock />
                  Yeni Şifre
                </label>
                <input
                  type="password"
                  className="form-input"
                  placeholder="••••••••"
                  value={passwordData.newPassword}
                  onChange={(e) => setPasswordData(prev => ({
                    ...prev,
                    newPassword: e.target.value
                  }))}
                  required
                  minLength={6}
                />
              </div>

              <div className="form-group">
                <label className="form-label">
                  <FiLock />
                  Yeni Şifre (Tekrar)
                </label>
                <input
                  type="password"
                  className="form-input"
                  placeholder="••••••••"
                  value={passwordData.confirmPassword}
                  onChange={(e) => setPasswordData(prev => ({
                    ...prev,
                    confirmPassword: e.target.value
                  }))}
                  required
                />
              </div>

              <button 
                type="submit" 
                className="btn btn-primary"
                disabled={saving}
              >
                {saving ? (
                  <>
                    <span className="spinner" style={{ width: 16, height: 16 }}></span>
                    Kaydediliyor...
                  </>
                ) : (
                  <>
                    <FiSave />
                    Şifreyi Değiştir
                  </>
                )}
              </button>
            </form>

            <div className="security-tips">
              <h4>Güvenlik İpuçları</h4>
              <ul>
                <li>En az 6 karakter uzunluğunda şifre kullanın</li>
                <li>Büyük/küçük harf, rakam ve özel karakter içeren şifreler tercih edin</li>
                <li>Şifrenizi düzenli olarak değiştirin</li>
                <li>Şifrenizi kimseyle paylaşmayın</li>
              </ul>
            </div>
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default AdminSettings;

